
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "@ember/test-helpers/-embroider-implicit-modules.js";
import "@ember/render-modifiers/-embroider-implicit-modules.js";
import "@ember/test-waiters/-embroider-implicit-modules.js";
